import * as React from 'react';

import cx from 'classnames';
import { SocialMediaLinks } from 'themes/common/components/NavItemSocial/SocialMediaLinks';

import { useNavigation } from 'hooks/navigation/useNavigation';

import { BagCounter } from 'routes/shop/bag/components/BagCounter/BagCounter';

import { OrganicNavItem } from './OrganicNavItem';

import s from './OrganicNavigation.module.css';

export const OrganicNavItems = ({ isMainNav = false }) => {
  const {
    showTeam,
    showPortfolio,
    showShopLink,
    aboutUrl,
    teamUrl,
    servicesUrl,
    portfolioUrl,
    contactUrl,
    packagesUrl,
    bookUrl,
    bagUrl,
    shopUrl,
    isPackagePurchaseEnabled,
    tracking,
    socialMediaUrls,
  } = useNavigation({
    styles: {
      overlay: s.overlay,
      overlayOpen: s.overlayOpen,
      overlayClosed: s.overlayClosed,
      menuButton: s.menuButton,
      menuContainer: s.menuContainer,
      menuContainerOpen: s.menuContainerOpen,
      menuContainerClosed: s.menuContainerClosed,
    },
  });

  return (
    <>
      <OrganicNavItem
        onClick={() => {
          tracking.navItemClicked('about');
        }}
        to={aboutUrl}
      >
        About
      </OrganicNavItem>
      {showTeam && (
        <OrganicNavItem
          onClick={() => tracking.navItemClicked('team')}
          to={teamUrl}
        >
          <span data-testid="our-team">
            {isMainNav ? (
              <>
                <span className={s.fullText}>Our Team</span>
                <span className={s.minimalText}>Team</span>
              </>
            ) : (
              'Our Team'
            )}
          </span>
        </OrganicNavItem>
      )}
      <OrganicNavItem
        onClick={() => tracking.navItemClicked('services')}
        to={servicesUrl}
      >
        Services
      </OrganicNavItem>
      {showPortfolio && (
        <OrganicNavItem
          onClick={() => tracking.navItemClicked('portfolio')}
          to={portfolioUrl}
        >
          Portfolio
        </OrganicNavItem>
      )}
      {packagesUrl && (
        <OrganicNavItem
          onClick={() => tracking.navItemClicked('packages')}
          to={packagesUrl}
        >
          Packages
        </OrganicNavItem>
      )}
      <OrganicNavItem
        onClick={() => tracking.navItemClicked('contact')}
        to={contactUrl}
      >
        Contact
      </OrganicNavItem>
      {isPackagePurchaseEnabled && (
        <OrganicNavItem
          to={bagUrl}
          className={cx(s.bagItem, s.hideOnDesktop)}
          ariaLabel="Bag preview"
        >
          <BagCounter size={24} />
        </OrganicNavItem>
      )}
      <OrganicNavItem
        onClick={() => tracking.navItemClicked('book')}
        className={s.bookNowCTA}
        to={bookUrl}
      >
        <span data-testid="book-now">
          {isMainNav ? (
            <>
              <span className={s.fullText}>Book Now</span>
              <span className={s.minimalText}>Book</span>
            </>
          ) : (
            'Book Now'
          )}
        </span>
      </OrganicNavItem>
      {showShopLink && (
        <OrganicNavItem
          onClick={() => tracking.navItemClicked('shop')}
          newTab
          to={shopUrl}
        >
          {isMainNav ? (
            <>
              <span className={s.fullText}>Shop Now</span>
              <span className={s.minimalText}>Shop</span>
            </>
          ) : (
            'Shop Now'
          )}
        </OrganicNavItem>
      )}

      <li>
        <SocialMediaLinks
          className={cx(s.socialMediaIcons)}
          urls={socialMediaUrls}
        />
      </li>
    </>
  );
};
